<template>
  <svg width="229px" height="92px" viewBox="0 0 229 92" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.673101381">
      <g transform="translate(-102.000000, -236.000000)" fill="#4BD3AF">
        <g transform="translate(5.000000, 204.000000)">
          <g transform="translate(97.295714, 32.272480)">
            <ellipse opacity="0.340661337" cx="113.991429" cy="45.527249" rx="76.57" ry="30.5435974"></ellipse>
            <ellipse opacity="0.214752907" cx="113.991429" cy="45.527249" rx="113.991429" ry="45.527249"></ellipse>
            <ellipse opacity="0.418014172" cx="110.537143" cy="44.3746604" rx="39.1485714" ry="15.5599459"></ellipse>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
